export function ErrorCodeBlock({ error, sessionId }: { error?: Error; sessionId?: string }) {
    const styles = {
        errorContainer: {
            padding: '20px 40px',
            overflow: 'auto',
            backgroundColor: '#E2E6EB',
            borderRadius: '5px',
        },
        errorMsg: {
            maxHeight: '40vh',
            color: 'black',
        },
    };

    if (error === undefined) {
        return null;
    }

    return (
        <div style={styles.errorContainer}>
            <pre style={{ ...styles.errorMsg, textAlign: 'left' }}>
                {`DD_SESSION_ID: ${sessionId ?? 'No datadog session id'}`}
            </pre>
            <pre style={{ ...styles.errorMsg, textAlign: 'left' }}>
                {error.toString()}
            </pre>
        </div>
    );
}
